import React from 'react';
import { useTranslation } from 'react-i18next';
import { Currency } from '@/data/models/manufacturing';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  handleManufacturing: (field: string, value: any) => void;
  handleManufacturingCostBlur: () => void;
};

export default function ManufacturingCostFormGroup({
  album,
  readonly,
  disabled,
  fieldHasErrors,
  findErrorMessage,
  handleManufacturing,
  handleManufacturingCostBlur,
}: Props) {
  const { t } = useTranslation();

  const hasCostError =
    fieldHasErrors('ManufacturingCostPerUnit') ||
    fieldHasErrors('manufacturingCostPerUnit');

  const costErrorMessage =
    findErrorMessage('ManufacturingCostPerUnit') ||
    findErrorMessage('manufacturingCostPerUnit');

  return (
    <>
      {!readonly ? (
        <div className="form-group" onBlur={handleManufacturingCostBlur}>
          <label className="col-sm-3 form-label">
            {t('product.editProduct.manufacturingCostPerUnit')}
          </label>
          <div className="col-sm-6 pair-input-container padding-left-0">
            <div className="col-sm-12 padding-right-0">
              <div className="pair-input">
                <div className="fixed-left">
                  <select
                    className={
                      fieldHasErrors('Currency')
                        ? 'form-select currency-select invalid-input'
                        : 'form-select currency-select'
                    }
                    value={album.albumMetaData?.manufacturing?.currency ?? ''}
                    onChange={(e) =>
                      handleManufacturing('currency', e.target.value || null)
                    }
                    disabled={disabled}
                  >
                    <option value=""></option>
                    {Object.keys(Currency).map((currency) => (
                      <option key={currency} value={currency}>
                        {currency}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="right-fill">
                  <input
                    id="manufacturingCostPerUnit"
                    type="text"
                    className={
                      hasCostError
                        ? 'form-control invalid-input'
                        : 'form-control'
                    }
                    value={
                      album.albumMetaData?.manufacturing?.manufacturingCostPerUnit?.toString() ??
                      ''
                    }
                    onChange={(e) =>
                      handleManufacturing(
                        'manufacturingCostPerUnit',
                        e.target.value
                      )
                    }
                    disabled={
                      disabled || !album.albumMetaData?.manufacturing?.currency
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {hasCostError ? (
            <div className="col-sm-3 popUp-container">{costErrorMessage}</div>
          ) : fieldHasErrors('Currency') ? (
            <div className="col-sm-3 popUp-container">
              {findErrorMessage('Currency')}
            </div>
          ) : null}
        </div>
      ) : (
        <ReadOnlyField
          id={'manufacturingCostPerUnit'}
          labelTitle={t('product.editProduct.manufacturingCostPerUnit')}
          value={[
            album.albumMetaData?.manufacturing?.manufacturingCostPerUnit,
            album.albumMetaData?.manufacturing?.currency,
          ]}
        ></ReadOnlyField>
      )}
    </>
  );
}
